import { createFileRoute } from "@tanstack/react-router";
import { BudgetTool } from "@/features/marketing/tools/budget-tool";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/$lang/wedding-budget-calculator")({
  head: SEO.budgetCalculator,
  component: BudgetTool,
});
